import type { SVGProps } from 'react';

const Borrow = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M7.25 19.25H4.75V12.75H7.25V14.75M7.25 19.25V14.75M7.25 19.25C14 19.25 19.25 16 19.25 16V13.75H13.25M7.25 14.75L10.78 12.868C10.9246 12.7907 11.086 12.7502 11.25 12.75H12.25C12.5152 12.75 12.7696 12.8554 12.9571 13.0429C13.1446 13.2304 13.25 13.4848 13.25 13.75M13.25 13.75V15L10.75 16.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0534 6.83151C14.0886 6.74654 14.1402 6.66935 14.2053 6.60435C14.2703 6.53927 14.3475 6.48765 14.4324 6.45242C14.5174 6.4172 14.6085 6.39907 14.7005 6.39907C14.7924 6.39907 14.8835 6.4172 14.9685 6.45242C15.0534 6.48765 15.1306 6.53927 15.1956 6.60435L16.8002 8.20975V2.90009C16.8002 2.71447 16.8739 2.53644 17.0052 2.40518C17.1364 2.27393 17.3145 2.20019 17.5001 2.20019C17.6857 2.20019 17.8637 2.27393 17.995 2.40518C18.1262 2.53644 18.2 2.71447 18.2 2.90009V8.20975L19.8045 6.60435C19.8695 6.53932 19.9467 6.48773 20.0317 6.45254C20.1167 6.41735 20.2077 6.39923 20.2997 6.39923C20.3917 6.39923 20.4827 6.41735 20.5677 6.45254C20.6527 6.48773 20.7299 6.53932 20.7949 6.60435C20.8599 6.66937 20.9115 6.74657 20.9467 6.83154C20.9819 6.9165 21 7.00756 21 7.09953C21 7.19149 20.9819 7.28256 20.9467 7.36752C20.9115 7.45248 20.8599 7.52968 20.7949 7.59471L17.9953 10.3943C17.9303 10.4594 17.8531 10.511 17.7681 10.5463C17.6831 10.5815 17.5921 10.5996 17.5001 10.5996C17.4081 10.5996 17.317 10.5815 17.2321 10.5463C17.1471 10.511 17.0699 10.4594 17.0049 10.3943L14.2053 7.59471C14.1402 7.52971 14.0886 7.45252 14.0534 7.36755C14.0181 7.28258 14 7.19151 14 7.09953C14 7.00755 14.0181 6.91647 14.0534 6.83151Z"
      fill="currentColor"
    />
  </svg>
);

export default Borrow;
